module.exports = __webpack_public_path__ + "img/icon-letter-w.c6ad59d5.svg";